export const EMPTY_MY_MEMBERSHIPS_OVERVIEW = {
  student: null,
  dashboard: {
    active_membership: "—",
    membership_expiry_date: "—",
    days_remaining: 0,
    total_memberships: 0,
    pending_renewals: 0,
    membership_status: "—",
    active_count: 0,
  },
  summary: null,
  timeline: [],
};
